import * as React from 'react';
import cx from 'clsx';

import styles from './ContentWrapper.module.scss';
import { useWindowSize } from 'src/hooks/useWindowSize';
import { SMALL_BREAKPOINT } from 'src/components/modular-grid/constants';

interface ContentWrapperPropTypes {
  children?: React.ReactNode;
  isSidebarInLayout?: boolean;
}

const ContentWrapper: React.FC<ContentWrapperPropTypes> = ({
  children = null,
  isSidebarInLayout,
}) => {
  const width = useWindowSize().width;
  const shouldContentBeVisible =
    width > SMALL_BREAKPOINT.max ||
    (width <= SMALL_BREAKPOINT.max && !isSidebarInLayout);
  return (
    <div
      id="contentWrapper"
      data-testid="contentWrapper"
      className={cx(styles.wrapper, {
        [styles.wrapperSmall]: width < SMALL_BREAKPOINT.max,
      })}
    >
      <>{shouldContentBeVisible ? children : null}</>
    </div>
  );
};

export default ContentWrapper;
